import { useState } from 'react';
import { LayoutDashboard, ClipboardList, Users, Calendar, Menu as MenuIcon, GraduationCap, Megaphone, BookOpen, BarChart3, Award, NotebookPen, Settings, X } from 'lucide-react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

const TABS = [
  { to: '/professor/dashboard', icon: LayoutDashboard, label: 'Início' },
  { to: '/professor/chamada', icon: ClipboardList, label: 'Chamada' },
  { to: '/professor/alunos', icon: Users, label: 'Alunos' },
  { to: '/professor/turmas', icon: Calendar, label: 'Turmas' },
  { to: '__menu__', icon: MenuIcon, label: 'Menu' },
];

const MENU_ITEMS = [
  { to: '/professor/dashboard', icon: LayoutDashboard, label: 'Início', color: '#2563eb' },
  { to: '/professor/chamada', icon: ClipboardList, label: 'Chamada', color: '#059669' },
  { to: '/professor/diario', icon: NotebookPen, label: 'Diário', color: '#0ea5e9' },
  { to: '/professor/comunicados', icon: Megaphone, label: 'Avisos', color: '#d97706' },
  { to: '/professor/turmas', icon: GraduationCap, label: 'Turmas', color: '#2563eb' },
  { to: '/professor/alunos', icon: Users, label: 'Alunos', color: '#1e40af' },
  { to: '/professor/avaliacoes', icon: Award, label: 'Notas', color: '#dc2626' },
  { to: '/professor/observacoes', icon: BookOpen, label: 'Observações', color: '#059669' },
  { to: '/professor/relatorios', icon: BarChart3, label: 'Relatórios', color: '#2563eb' },
  { to: '/professor/perfil', icon: Settings, label: 'Perfil', color: '#64748b' },
];

interface Props {
  hasPendencias: boolean;
  /** Comunicados / notificações não lidas (bolão). */
  unreadComunicados?: number;
}

export function MobileTabBar({ hasPendencias, unreadComunicados = 0 }: Props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const showMenuDot = hasPendencias || unreadComunicados > 0;

  return (
    <>
      <div className="mobile-tab-bar dark md:hidden">
        {TABS.map(tab => {
          const Icon = tab.icon;
          const isMenu = tab.to === '__menu__';
          const active = !isMenu && location.pathname.startsWith(tab.to);
          return (
            <button
              key={tab.to}
              className={`mobile-tab-item ${active ? 'active' : ''}`}
              onClick={() => {
                if (isMenu) { setMenuOpen(true); return; }
                navigate(tab.to);
              }}
            >
              <Icon size={20} strokeWidth={active ? 2.5 : 2} />
              <span>{tab.label}</span>
              {isMenu && showMenuDot && <span className="mobile-alert-dot" />}
            </button>
          );
        })}
      </div>

      {menuOpen && (
        <>
          <div className="mobile-menu-overlay md:hidden" onClick={() => setMenuOpen(false)} />
          <div className="mobile-menu-sheet md:hidden">
            <div className="mobile-menu-handle" />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
              <span style={{ fontSize: '0.88rem', fontWeight: 800, color: 'var(--text-main)' }}>Menu</span>
              <button onClick={() => setMenuOpen(false)} style={{ border: 'none', background: 'var(--bg-main, #f2f2f7)', borderRadius: 10, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--text-muted)' }}>
                <X size={16} />
              </button>
            </div>
            <div className="mobile-menu-grid">
              {MENU_ITEMS.map(item => {
                const Icon = item.icon;
                const isComunicados = item.to === '/professor/comunicados';
                return (
                  <button key={item.to} className="mobile-menu-grid-item" onClick={() => { setMenuOpen(false); navigate(item.to); }}>
                    <div style={{ position: 'relative', width: 36, height: 36, borderRadius: 10, background: item.color + '14', display: 'flex', alignItems: 'center', justifyContent: 'center', color: item.color }}>
                      <Icon size={18} />
                      {isComunicados && unreadComunicados > 0 && (
                        <span
                          style={{
                            position: 'absolute',
                            top: -4,
                            right: -4,
                            minWidth: 16,
                            height: 16,
                            padding: '0 4px',
                            borderRadius: 8,
                            background: '#ef4444',
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 800,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: 1,
                          }}
                        >
                          {unreadComunicados > 9 ? '9+' : unreadComunicados}
                        </span>
                      )}
                    </div>
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </>
  );
}
